import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AppBody from "../../components/AppBody";
import CreateTrainingCourseModel from "./CreateTrainingCourseModel";
import { trainingCourseList } from "../../../actions/admin/certification/training_course_action";
import {
  getTrainingModule,
  trainingModuleList,
} from "../../../actions/admin/certification/training_module_action";
import CreateTrainingModulesModel from "./CreateTrainingModulesModel";
import {
  createTrainingTopic,
  resetTopicStatus,
  updateTopicStatus,
  updateTrainingTopic,
} from "../../../actions/admin/certification/training_topic_action";
import { ToastContainer, toast } from "react-toastify";

const CreateTrainingCourse = () => {
  const [moduleShow, setModuleShow] = useState(false);
  const [courseShow, setCourseShow] = useState(false);
  const state = useSelector((state) => state.trainingCourseReducer);
  const moduleState = useSelector((state) => state.trainingModuleReducer);
  const topicState = useSelector((state) => state.trainingTopicReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(trainingCourseList());
  }, []);

  const [traningCourse, setTrainingCourse] = useState({
    course: "",
    module: "",
    topics: [],
  });
  const [setShow, setShowElement] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      createTrainingTopic({
        course: traningCourse.course,
        module: traningCourse.module,
        topics: topicList,
      })
    );
  };
  //createTrainingTopic

  const resetCourseModel = () => {
    setCourseShow(false);
  };

  const resetModulesModel = () => {
    dispatch(trainingModuleList({ course_id: traningCourse.course }));
    setModuleShow(false);
  };

  const [topic, setTopics] = useState("");
  const [topicList, setTopicList] = useState([]);

  const addTopicToLits = () => {
    if (topic) {
      topicList.push(topic);
      setTopics(" ");
    }
  };

  const deleteTopicItem = (name) => {
    const arr = topicList.filter(function (item) {
      return item !== name;
    });
    setTopicList(arr);
    setTrainingCourse({ ...traningCourse, topics: arr });
  };

  const navigate = useNavigate();

  if (topicState.is_done && topicList.length > 0) {
    setTopicList([]);
    //navigate("/admin/training-course-list");
    //dispatch(updateTopicStatus());
    toast("Record Added Successfully!", {
      type: "success",
      position: "top-center",
    });
    dispatch(resetTopicStatus());
  }

  if (setShow) {
    setTimeout(function () {
      setShowElement(false);
    }, 10000);
  }

  const viewCourse = () => {
    navigate("/admin/training-course-list");
    dispatch(updateTopicStatus());
  };

  const resetCourse = () => {
    setTopicList([]);
  };

  return (
    <AppBody
      loading={state.loading || moduleState.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <Link to={"/all-courses"} className="d-inline-block mt-2">
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                  Create Training Course
                </h4>
              </div>

              <div className="card-body  p-4 w-100 border-0 ">
                {courseShow && (
                  <CreateTrainingCourseModel
                    show={courseShow}
                    handelCloseCrourseModel={() => resetCourseModel()}
                  />
                )}
                {moduleShow && (
                  <CreateTrainingModulesModel
                    show={moduleShow}
                    handelCloseModuleModel={() => resetModulesModel()}
                  />
                )}

                <ToastContainer />

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Course Name
                        </label>
                        <select
                          className="form-control"
                          name={"course"}
                          onChange={(e) => {
                            if (e.target.value) {
                              dispatch(
                                trainingModuleList({
                                  course_id: e.target.value,
                                })
                              );
                            }
                            setTrainingCourse({
                              ...traningCourse,
                              course: e.target.value,
                            });
                          }}
                        >
                          <option value={""}>Select Course</option>
                          {state.list &&
                            state.list.map((li, i) => (
                              <option value={li.id}>{li.name}</option>
                            ))}
                        </select>
                      </div>
                      <span className="error-msg">
                        {topicState.errors.course ? state.errors.course : ""}
                      </span>
                    </div>

                    <div className="col-lg-2 pt-2">
                      <input
                        type="button"
                        name="submit"
                        value="Add New"
                        onClick={() => setCourseShow(true)}
                        className="btn-common px-3 mt-30"
                      />
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Select Module Name
                        </label>
                        <select
                          className="form-control"
                          name={"module"}
                          onChange={(e) =>
                            setTrainingCourse({
                              ...traningCourse,
                              module: e.target.value,
                            })
                          }
                        >
                          <option value={""}>Select Module</option>
                          {moduleState.list &&
                            moduleState.list.map((li, i) => (
                              <option value={li.id}>{li.name}</option>
                            ))}
                        </select>
                        <span className="error-msg">
                          {topicState.errors.module ? state.errors.module : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-2 pt-2">
                      <input
                        type="button"
                        name="submit"
                        value="Add New"
                        onClick={() => setModuleShow(true)}
                        className="btn-common px-3 mt-30"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 mb-3">
                      <label className="mont-font fw-600 font-xsss">
                        Topic Name
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-8 mb-3">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Topic Name"
                          value={topic}
                          onChange={(e) => setTopics(e.target.value)}
                        />
                        <span className="error-msg">
                          {topicState.errors.topics ? state.errors.topics : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 pt-2">
                      <input
                        type="button"
                        name="submit"
                        value="Add"
                        className="btn-common px-3"
                        onClick={() => addTopicToLits()}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 mb-3">
                      <ul>
                        {topicList.map((topic, i) => (
                          <li key={i}>
                            <span className={"pt-2"}>{topic}</span>
                            <button
                              className="btn approve_btn btn-common"
                              type="button"
                              onClick={() => deleteTopicItem(topic)}
                            >
                              Delete
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <input
                        type="submit"
                        name="submit"
                        value="Submit"
                        className="btn-common px-5"
                      />
                      <input
                        type="button"
                        name="reset"
                        value="Reset"
                        className="btn-common px-5"
                        onClick={() => resetCourse()}
                      />
                      <input
                        type="button"
                        name="submit"
                        value="View Course"
                        className="btn-common px-5"
                        onClick={() => viewCourse()}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default CreateTrainingCourse;
